import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [search, setSearch] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/game-reviews?keyword=${encodeURIComponent(search.trim())}`);
    } else {
      navigate('/game-reviews');
    }
    setShowMobileSearch(false); // Đóng popup search trên mobile sau khi tìm kiếm
  };

  return (
    <header className="header-root">
      <div className="header-inner">
        {/* Logo */}
        <a href="/" className="header-logo">
          <span style={{ fontSize: 32, fontWeight: 700, fontFamily: 'inherit', display: 'flex', alignItems: 'center', letterSpacing: 1 }}>
            <span style={{ color: '#d32f2f' }}>Gam</span>
            <span style={{ color: '#ad1457' }}>eLi</span>
            <span style={{ color: '#512da8' }}>m</span>
            <span style={{ color: '#7c43bd', fontStyle: 'italic', marginLeft: 2 }}>!</span>
          </span>
        </a>
        {/* Mobile icons */}
        <div className="header-mobile-icons">
          <button
            className="search-icon-mobile"
            aria-label="Search"
            onClick={() => setShowMobileSearch(!showMobileSearch)}
          >
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" stroke="#bfa16c" strokeWidth="2"/><path stroke="#bfa16c" strokeWidth="2" strokeLinecap="round" d="M20 20l-3-3"/></svg>
          </button>
          <button
            className="header-hamburger"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#181512" strokeWidth="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
        {/* Search Bar (desktop) */}
        <div className="header-search">
          <form style={{ width: 350 }} onSubmit={handleSearch}>
            <div style={{
              width: '100%',
              background: '#fff',
              border: '1px solid #e0bfa3',
              borderRadius: 7,
              display: 'flex',
              alignItems: 'center',
              padding: '0 12px',
              height: 38
            }}>
              <input
                type="text"
                placeholder="Search games here..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleSearch(e); }}
                style={{
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  fontSize: 16,
                  background: 'transparent',
                  fontFamily: 'inherit',
                  color: '#444',
                }}
              />
              <button
                type="submit"
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginLeft: 6,
                  cursor: 'pointer',
                  color: '#bfa16c',
                  display: 'flex',
                  alignItems: 'center',
                }}
                tabIndex={0}
                aria-label="Search"
              >
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" stroke="#bfa16c" strokeWidth="2"/><path stroke="#bfa16c" strokeWidth="2" strokeLinecap="round" d="M20 20l-3-3"/></svg>
              </button>
            </div>
          </form>
        </div>
        {/* Menu (desktop) */}
        <nav className="header-nav">
          <a href="/game-reviews" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }}>Games</a>
          <a href="/app-reviews" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }}>Apps</a>
          <a href="/blogs" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }}>Blog</a>
          <a href="/about-us" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }}>About Us</a>
        </nav>
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="header-mobile-menu">
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <a href="/game-reviews" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>Games</a>
              <a href="/app-reviews" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>Apps</a>
              <a href="/blogs" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>Blog</a>
              <a href="/about-us" style={{ fontWeight: 700, color: '#181512', fontSize: 17, textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>About Us</a>
            </nav>
          </div>
        )}
      </div>
      {/* Mobile Search Popup */}
      {showMobileSearch && (
        <div className="mobile-search-popup">
          <form onSubmit={handleSearch} style={{ width: '100%' }}>
            <div style={{
              width: '100%',
              background: '#fff',
              border: '1px solid #e0bfa3',
              borderRadius: 7,
              display: 'flex',
              alignItems: 'center',
              padding: '0 12px',
              height: 38,
              marginTop: 8
            }}>
              <input
                type="text"
                placeholder="Search games here..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                autoFocus
                style={{
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  fontSize: 16,
                  background: 'transparent',
                  fontFamily: 'inherit',
                  color: '#444',
                }}
              />
              <button
                type="submit"
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginLeft: 6,
                  cursor: 'pointer',
                  color: '#bfa16c',
                  display: 'flex',
                  alignItems: 'center',
                }}
                tabIndex={0}
                aria-label="Search"
              >
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" stroke="#bfa16c" strokeWidth="2"/><path stroke="#bfa16c" strokeWidth="2" strokeLinecap="round" d="M20 20l-3-3"/></svg>
              </button>
              <button type="button" className="close-mobile-search" aria-label="Close" onClick={() => setShowMobileSearch(false)} style={{marginLeft: 8, background: 'none', border: 'none', cursor: 'pointer', fontSize: 20}}>&times;</button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header; 